<template>
  <div>
    <el-cascader style="width: 100%;" v-if="show" v-model="addrs" placeholder="请选择省市区" :options="addr" @change="handleChange"
          :disabled="isRead"></el-cascader> 
<!--      <el-col v-if="!isRead" :span="1" style="padding-left: 0; font-size: 20px; color: #cccccc">-->
<!--        <i class="el-icon-location-outline" @click="clickaddressbtn"></i>-->
<!--      </el-col>--> 
  </div>
</template>
<script>
import { GetaddressList } from "@/api/mySupplier/myAddress";
let addresData = () => {
  return new Promise((resovle, reject) => {
    GetaddressList().then((res) => {
      resovle(res.data);
    });
  });
};
export default {
  data() {
    return {
      addr: [],
      addrs: [],
      nameStr: [],
      show: true,
    };
  },
  props: {
    codeStrSource: {
      type: Array,
      default: () => [],
    },
    nameStrSource: {
      type: Array,
      default: () => [],
    },
    isRead: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    codeStrSource: {
      handler(nv, ov) {
        if (this.codeStrSource.length) {
          this.addrs = nv;
        }
      },
      immediate: true,
      deep: true,
    },
    nameStrSource: {
      handler(nv, ov) {
        if (nv.length != 0) {
          if(nv[0]==""){
            this.addrs=[]
          }else{
            this.getCodeByNameList();
          }
        } else {
          this.addrs=[]
        }
        this.$emit("changeaddrs",{addrs:this.addrs});
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    clickaddressbtn() {
      if (!this.isRead) {
        this.$emit("clickaddressbtn");
      }
    },
    getLabelNameCaser(arr, many, value) {
      let str = arr.find((el) => el.value == value[many]);
      return str;
    },
    handleChange(value) {
      let childrenStr = [];
      this.nameStr=[]
      value.forEach((ele, idx) => {
        if (idx == 0) {
          let { label, children } = this.getLabelNameCaser(
            this.addr,
            idx,
            value
          );
          if (children != undefined) {
            childrenStr = [...children];
          }
          this.nameStr.push(label);
        } else {
          let { label, children } = this.getLabelNameCaser(
            childrenStr,
            idx,
            value
          );
          if (children != undefined) {
            childrenStr = [...children];
          }
          this.nameStr.push(label);
        }
      });
      this.$emit("change", { name: this.nameStr, code: this.addrs });
    },
    getTreeList(arrs) {
      let arr = arrs.filter(ele => ele.code != '00')
      arr.forEach((ele) => {
        if (ele.children != undefined && ele.children.length >= 1) {
          this.getTreeList(ele.children);
        } else if (ele.children == undefined) {
          ele.children = undefined;
        }
        ele.label = ele.name;
        ele.value = ele.code;
      });
      return arr;
    },
    getData() {
      addresData().then(res => {
        this.addr = this.getTreeList(res);
        console.log(this.addr)
        this.getCodeByNameList();
      });
    },
    async getCodeByNameList() {
      for (let idx of this.addr) {
        if (idx.label == this.nameStrSource[0]) {
          this.$set(this.addrs, 0, idx.value);
          if (idx.children != undefined) {
            for (let v of idx.children) {
              if (v.label == this.nameStrSource[1]) {
                this.$set(this.addrs, 1, v.value);
                if (v.children != undefined) {
                  for (let t of v.children) {
                    if (t.label == this.nameStrSource[2]) {
                      this.$set(this.addrs, 2, t.value);
                      this.show = false;
                      this.$nextTick(() => {
                        this.show = true;
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
  },
};
</script>
